import MatchCorrectScoreMarketResultModel from "./MatchCorrectScoreMarketResultModel";
import MatchPlayerMarketResultModel from "./MatchPlayerMarketResultModel";

export default class MatchMarketsResultsModel {
  public FT_1X2: string = null;
  public HT_1X2: string = null;
  public BOTH_TEAMS_SCORE: boolean = null;
  public DOUBLE_CHANCE: string[] = null;
  public HT_FT: string = null;
  public RED_CARD_MATCH: boolean = null;
  public PENALTY_MATCH: boolean = null;
  public CORNERS_MATCH: number = null;
  public PLAYER_YELLOW_CARD: MatchPlayerMarketResultModel[] = [];
  public PLAYER_RED_CARD: MatchPlayerMarketResultModel[] = [];
  public PLAYER_SCORE_FIRST_GOAL: MatchPlayerMarketResultModel =
    new MatchPlayerMarketResultModel();
  public PLAYER_SCORE: MatchPlayerMarketResultModel[] = [];
  public PLAYER_SCORE_TWICE: MatchPlayerMarketResultModel[] = [];
  public PLAYER_SCORE_HATTRICK: MatchPlayerMarketResultModel[] = [];
  public CORRECT_SCORE: MatchCorrectScoreMarketResultModel =
    new MatchCorrectScoreMarketResultModel();
  public CORRECT_SCORE_ADVANCED: MatchCorrectScoreMarketResultModel =
    new MatchCorrectScoreMarketResultModel();
  public CORRECT_SCORE_HT: MatchCorrectScoreMarketResultModel =
    new MatchCorrectScoreMarketResultModel();
  public OVER_GOALS_0_5: boolean = null;
  public OVER_GOALS_1_5: boolean = null;
  public OVER_GOALS_2_5: boolean = null;
  public OVER_GOALS_3_5: boolean = null;
  public OVER_GOALS_4_5: boolean = null;
  public OVER_GOALS_5_5: boolean = null;
  public OVER_GOALS_6_5: boolean = null;
  public OVER_CORNERS_6_5: boolean = null;
  public OVER_CORNERS_7_5: boolean = null;
  public OVER_CORNERS_8_5: boolean = null;
  public OVER_CORNERS_9_5: boolean = null;
  public OVER_CORNERS_10_5: boolean = null;
  public OVER_CORNERS_11_5: boolean = null;
  public OVER_CORNERS_12_5: boolean = null;
  public OVER_CORNERS_13_5: boolean = null;
}
